import React, {Component} from 'react';
import { connect } from 'react-redux';
// import { Segment, Tab } from 'semantic-ui-react'
import qs from 'query-string';
import _ from 'underscore';

import {
    getMHCYoutubeVideosDetail,
} from '../../actions';
import HealthArticlesView from '../../component/healtharticles/health_articles_view';
import HealthVideoView from '../../component/healtharticles/health_video_view';

class HealthArticlesViewPage extends Component {
    state = {
        type: null,
        id: null,
    }
    componentDidMount() {
        // this.props.getMHCArticlesFullList();
        // this.props.getMHCYoutubeVideosFullList();
        const { search } = this.props.location;
        const parsedQueryString = qs.parse(search);
        const {
            id, type
        } = parsedQueryString;
        this.setState({id, type});
        if (type === '2') {
            const {accessToken} = this.props.user;
            this.props.getMHCYoutubeVideosDetail(id, accessToken);
        }
    }
    render() {
        if (this.state.type === '1') {
            const selectedArticleToView = _.find(this.props.articleFullList, (article) => article.uuid === this.state.id);
            return (
                <HealthArticlesView article={selectedArticleToView}/>
            );
        }
        if (this.state.type === '2') {
            return (
                <HealthVideoView videos={this.props.articleVideoDetail}/>
            );
        }
        return (
            <p>
                No Matching Article to Load
            </p>
        );
    }
}

const mapStateToProps = state => {
    return {
        user: state.user.user,
        articleFullList: state.appConfig.articleFullList,
        articleVideoFullList: state.appConfig.articleVideoFullList,
        articleVideoDetail: state.appConfig.articleVideoDetail,
    }
}

export default connect(mapStateToProps, {
    getMHCYoutubeVideosDetail
})(HealthArticlesViewPage);